import React from 'react';

const BASE = 'https://www.pinpointfieldservices.com';

const personas = [
  {
    heading: 'For Title Companies',
    href: `${BASE}/industries/title-companies/`,
    copy: 'Stop scrambling for notaries at month-end. We assign a closer you can count on — someone who picks up when we call.',
  },
  {
    heading: 'For Real Estate Attorneys',
    href: `${BASE}/industries/real-estate-attorneys/`,
    copy: 'We handle the notarization logistics so your team can focus on the legal work.',
  },
  {
    heading: 'For Mortgage Lenders',
    href: `${BASE}/industries/mortgage-lenders/`,
    copy: 'Mobile closings and RON, $2M E&O, MISMO-compliant. Coverage across all 50 states.',
  },
];

const HomepagePersonaCards = () => (
  <section className="py-10 bg-white border-b border-neutral-200">
    <div className="container">
      <div className="row g-4">
        {personas.map(({ heading, href, copy }) => (
          <div key={heading} className="col-md-4">
            <a
              href={href}
              className="d-block h-100 text-decoration-none"
              style={{
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '1.5rem',
                color: 'inherit',
                transition: 'box-shadow 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a202c', marginBottom: '0.75rem' }}>
                {heading}
              </h3>
              <p style={{ fontSize: '0.95rem', color: '#4a5568', marginBottom: '1rem', lineHeight: '1.6' }}>
                {copy}
              </p>
              <span style={{ color: '#00bfff', fontWeight: '600', fontSize: '0.9rem' }}>
                Learn more →
              </span>
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HomepagePersonaCards;
